import { Component, Host, h, Prop } from '@stencil/core';

@Component({
  tag: 'lilu-language-selector',
  styleUrl: 'lilu-language-selector.scss',
  shadow: false,
})
export class LiluLanguageSelector {
  @Prop() mode?: string;
  @Prop() selectedLang?: string;

  componentDidLoad() {
    if (this.mode === 'header') {
      const elSelect = document.querySelector('lilu-language-selector select') as HTMLSelectElement;
      this.selectedLang = elSelect.options[elSelect.selectedIndex].text;
    }
  }

  redirectToLanguage(event) {
    window.location.href = event.target.value;
  }

  render() {
    if (this.mode === 'header') {
      return (
        <Host>
          <div class="language-selector">
            <lilu-icon color="nero" type="icon-globus-01"></lilu-icon>
            <span class="language-selector-label">{this.selectedLang}</span>
          </div>
          <select class="language-selector-select" onChange={event => this.redirectToLanguage(event)}>
            <slot name="languages"></slot>
          </select>
        </Host>
      );
    } else if (this.mode === 'menu') {
      return (
        <Host>
          <ul class="language-selector-list">
            <slot name="languages"></slot>
          </ul>
        </Host>
      );
    } else {
      return null;
    }
  }
}
